import React from "react";
import style from "./PreviewHeaderView.module.scss";
import { PreviewHeaderViewBloc } from "./PreviewHeaderViewBloc";
import LinksAndQRCodesView from "../LinksAndQRCodes/LinksAndQRCodesView";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import cls from "classnames";
import { useAISaasContainer } from "../AISaas/container";
import { useDispatch } from "react-redux";
import { useHomeUsePluginContainer } from "../../../custom-hooks/HomeUsePluginRoot/container";
import useState from "react-usestateref";
import func from "@uikit/func";
import store from "@store/index";
import { logEvent } from "@uikit/service/amplitude";
import { useHomeChildContainer } from "@custom-hooks/HomeUsePluginRoot/childContainer";
import { Popover, Button } from "antd";
import { studioActions } from "@store/studio";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { PublishSuccessIcon } from "./icons/PublishSuccessIcon";
import { SettingIcon } from "./icons/SettingIcon";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { getIt } from "@uikit/getIt";
import { PreviewPaneStore } from "@uiview/views/PreviewPane/PreviewPaneStore";
import { Meta } from "imagica-corekit/dist/base/cutil/Meta";
import isBlank from "@sedan-utils/is-blank";
import { PreviewUtil } from "imagica-corekit/dist/cases/preview/PreviewUtil";

interface Props {
  inOrOutSetting: (bol: boolean) => void;
  backPreview: () => void;
}

// 组件
const PreviewHeaderView = (headerProps: Props) => {
  const bloc = new PreviewHeaderViewBloc();
  const { props } = useAISaasContainer();
  const { homeReactFlowState } = useHomeUsePluginContainer();
  const { selectedUI } = homeReactFlowState;

  const { handleSave } = useHomeChildContainer();
  const { disabledPublish, getPublishMetadata, getSelectedTemplate } = usePreviewAppStore();

  const dispatch = useDispatch();

  const needAInputField = "Add an input to publish";
  const needAOutputField = "Add content to publish";
  const nothing = "Add input/content to publish";
  const nosubscriptionPrice = "Set prices for subscription projects";

  const [shareLoading, setShareLoading] = useState(false);
  const featureTags = useFeatureTags();

  const previewPaneStore = getIt(PreviewPaneStore);
  const previewPaneState = useStore(previewPaneStore).value;

  const setSelectedTemplate = (val: any) => {
    dispatch(studioActions.setSelectedTemplate(val));
  };

  const nothingPublish = func.isEmpty(props.saasUIData?.output) && func.isEmpty(props.saasUIData?.input);
  const subscriptionAndNoPrice = () => {
    const template = store.getState().studio.selectedTemplate;
    const item = bloc.getActivePublishMetadata(template);
    return (
      item?.charge_option === "Subscription" &&
      (func.isEmpty(item?.subscription_price) || Number(item.subscription_price) === 0)
    );
  };
  const showPublishTips = (disabledPublish && shareLoading === false) || subscriptionAndNoPrice();

  // sutd-1722: published_metadata
  const published_metadata = getPublishMetadata();

  const returnPage = () => {
    logEvent("click", { target: "publish_preview_back" });
    if (previewPaneState.settingPageStatus) {
      previewPaneStore.settingPageStatus(false);
      return;
    }
    headerProps.backPreview();
  };

  async function clickShareBtn() {
    if (showPublishTips || shareLoading) return;
    // sutd-1722: published_metadata
    // let published_metadata = selectedTemplate?.published_metadata || {}
    let published_metadata = getPublishMetadata() || {};

    if (
      selectedUI === "saas" ||
      // || (util.isEmpty(selectedTemplate?.published_metadata)
      (func.isEmpty(published_metadata) &&
        func.isEmpty(published_metadata) &&
        bloc.feature_tags.showSubscriptionFeaturesToggle &&
        selectedUI === "saasV2")
    ) {
      published_metadata = {
        uuid: "",
        original: true,
        stripe_product_id: "",
        stripe_price_id: "",
        stripe_account_id: "",
      };
    }
    setShareLoading(true);
    try {
      let shareLink = "";
      // const index = selectedTemplate.index || selectedTemplate.uuid
      // save after generating sharable link if index exists
      // if(!util.isEmpty(index)) {
      //   shareLink = await genLink(index)
      // }
      // save before generating sharable link to get index if index does not exists
      const template = store.getState().studio.selectedTemplate;
      const data: any = {
        templateObj: template,
        shareObj: { share: true, shareLink },
        params: { published_metadata },
        showPublishTips,
      };

      const { updated_project } = await handleSave(data);

      if (!updated_project) {
        throw new Meta("Error", "Unable to create shared project");
      }
      setShareLoading(false);
      setSelectedTemplate(updated_project);
      await bloc.handleSubscription(updated_project);
      const selectTemlate = getSelectedTemplate();
      const eventProps = bloc.getPublishEventProps(selectTemlate);
      switch (selectedUI) {
        case "saas":
          logEvent("publish_as_webapp", { URL: updated_project.published_metadata.link, ...eventProps });
          break;
        case "saasV2":
          logEvent("publish_as_saas", { URL: updated_project.published_metadata.link });
          break;
        case "thinkingApp":
          logEvent("publish_as_thinkingapp", { URL: updated_project.published_metadata.link });
          break;
        default:
          break;
      }
    } catch (error: any) {
      setShareLoading(false);
      console.error("clickShareBtn", error);
      func.messageUtil(error);
    }
  }
  const onOpenChange = (open: boolean) => {
    previewPaneStore.openTitleIconTooltip(open);
  };

  const publishBtnStyl = cls(style.buttonBox, !showPublishTips ? style.available : style.disableBox);
  const publishPopoverContet = showPublishTips
    ? nothingPublish
      ? nothing
      : subscriptionAndNoPrice()
      ? nosubscriptionPrice
      : disabledPublish
      ? needAInputField
      : needAOutputField
    : "";
  const titleString = props.saasUIData.v2App?.appName || "";
  const getCustomDomain = () => {
    if (props.saasUIData.settings?.domain?.data?.domainCheckStatus !== "connected") {
      return undefined;
    }
    const inputValue = props.saasUIData.settings?.domain?.data?.inputValue;
    if (isBlank(inputValue)) {
      return undefined;
    }
    const host = props.saasUIData.settings?.domain?.data?.hostInputValue;
    return PreviewUtil.combineHostAndDomain(isBlank(host) ? "www" : host || "", inputValue || "");
  };
  const LinksAndQRCodesUrl = getCustomDomain() || published_metadata?.link;

  return (
    <div className={cls(style.previewHeaderBox)} data-testid="PreviewHeaderView">
      {featureTags.enablePublishV3 ? (
        <>
          <div className={cls({ [style.hideHeader]: previewPaneState.settingPageStatus })}>
            <img
              className={style.leftBackBox}
              onClick={() => returnPage()}
              src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Left.svg`}
              width="20"
              alt="icon"
            />
            <div className={style.characters}>
              <div className={style.title}>
                {titleString}
                {!func.isEmpty(published_metadata?.link) && (
                  <Popover
                    content={bloc.publishStr()}
                    placement="top"
                    trigger="hover"
                    overlayClassName={style.publishIconOverlay}
                    getPopupContainer={e => e}
                    onOpenChange={(open: boolean) => onOpenChange(open)}
                  >
                    <div className={style.PublishSuccessIcon}>
                      <PublishSuccessIcon />
                    </div>
                  </Popover>
                )}
              </div>
            </div>
          </div>
          <div className={style.clickBox}>
            <Popover
              className={style.buttonBox}
              content={publishPopoverContet}
              getPopupContainer={e => e}
              placement="top"
              trigger="hover"
              onOpenChange={(open: boolean) => onOpenChange(open)}
              overlayClassName={cls(style.popoverOverlay, { [style.popoverOverlayShow]: !showPublishTips })}
            >
              <div className={style.publishWrap}>
                <Button
                  className={publishBtnStyl}
                  loading={shareLoading}
                  disabled={showPublishTips}
                  type="primary"
                  shape="round"
                  onClick={() => clickShareBtn()}
                  data-testid="PublishShareButton"
                >
                  {shareLoading === false ? "Publish" : ""}
                </Button>
              </div>
            </Popover>
            <div className={style.buttonBox} onClick={() => headerProps.inOrOutSetting(true)}>
              <SettingIcon />
              Settings
            </div>
            {!func.isEmpty(published_metadata?.link) && (
              <LinksAndQRCodesView
                url={LinksAndQRCodesUrl as string}
                title={titleString}
                uuid={published_metadata?.uuid ?? ""}
              />
            )}
          </div>
        </>
      ) : (
        <>
          <img
            className={style.leftBackBox}
            onClick={() => headerProps.backPreview()}
            src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Left.svg`}
            width="20"
            alt="icon"
          />
          <div className={style.characters}>
            <div className={style.title}>{bloc.selectedTemplate.name}</div>
            <div className={style.subTitle}>{shareLoading ? "Publishing...  " : bloc.publishStr()}</div>
          </div>

          {/* {
        !util.isEmpty(bloc.selectedTemplate?.published_metadata?.link) ?
          <LinksAndQRCodesView url={bloc.selectedTemplate.published_metadata.link}/>
        : null
      } */}
          {/* // sutd-1722: published_metadata */}
          {!func.isEmpty(published_metadata?.link) ? (
            <LinksAndQRCodesView
              url={LinksAndQRCodesUrl as string}
              title={titleString}
              uuid={published_metadata?.uuid ?? ""}
            />
          ) : null}

          <div className={style.clickBox}>
            <Popover
              className={`${style.originBox} ${style.buttonBox}`}
              content={publishPopoverContet}
              getPopupContainer={e => e}
              placement="top"
              trigger="hover"
              overlayClassName={cls(style.popoverOverlay, { [style.popoverOverlayShow]: !showPublishTips })}
            >
              <div className={style.publishWrap}>
                <Button
                  className={publishBtnStyl}
                  loading={shareLoading}
                  disabled={showPublishTips}
                  type="primary"
                  shape="round"
                  onClick={() => clickShareBtn()}
                  data-testid="PublishShareButton"
                >
                  {shareLoading === false ? "Publish" : ""}
                </Button>
              </div>
            </Popover>
            <div className={`${style.originBox} ${style.buttonBox}`} onClick={() => headerProps.inOrOutSetting(true)}>
              <img src={`${settings.S3CDN}${settings.viewAssetsPath}theme.png`} width="20" alt="icon" />
              Settings
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewHeaderView;
